/**文献对比分析表格 */
<template>
  <div class="comparison-table">
    <el-table
      ref="tableRef"
      v-loading="ifLoading"
      :data="tableDataTemp"
      :header-cell-style="{ color: '#333', fontWeight: 550 }"
      :cell-style="getCellStyle"
      :row-style="{ height: tableStyleTemp.lineHeight + 'px' }"
      empty-text=" "
      @selection-change="handleSelectionChange"
      @header-dragend="handleDragTableWidth"
      @cell-mouse-enter="handleMouseEnter"
      @cell-mouse-leave="handleMouseLeave"
      border
    >
      <el-table-column type="selection" width="55" />
      <el-table-column
        prop="title"
        label="标题"
        fixed="left"
        :width="tableStyleTemp.titleColumnWidth"
      >
        <template #header>
          <img :src="AI_READING_TYPE_IMAGE['title']" class="header-img" />
          标题
        </template>
        <template #default="{ row }">
          <div style="padding: 20px 15px">{{ row.title }}</div>
          <div class="line-icon">
            <div class="line-option">
              <el-tooltip content="展开详情" placement="top" effect="dark">
                <div
                  class="option-icon"
                  v-show="row?.ifShowTitleIcon && !showUpdateButton(row)"
                  @click="handleClickUpdate(row, 'DETAIL')"
                >
                  <i class="iconfont icon-a-wenxianduibizhankai"></i>
                </div>
              </el-tooltip>
              <div
                class="option-text"
                v-show="row?.ifShowTitleIcon && showUpdateButton(row)"
                @click="handleClickIgnoreUpdate(row)"
              >
                <span class="ignore-update">忽略更新</span>
              </div>
              <el-tooltip content="查看更新" placement="top" effect="dark">
                <div
                  class="option-icon"
                  @click="handleClickUpdate(row, 'UPDATE')"
                  v-show="showUpdateButton(row)"
                >
                  <i class="iconfont icon-jichu_gengxin"></i>
                </div>
              </el-tooltip>
            </div>
          </div>
        </template>
      </el-table-column>
      <el-table-column
        v-for="item in tableColumnsTemp"
        :prop="item.name"
        :label="item.label"
        :width="item.columnWidth || tableStyleTemp.columnWidth"
        :key="item.name"
      >
        <template #header>
          <img
            :src="
              AI_READING_TYPE_IMAGE[item.name] ||
              AI_READING_TYPE_IMAGE['custom']
            "
            class="header-img"
          />
          {{ item.label }}
        </template>
        <template #default="{ row }">
          <div
            :class="`fit-content-${row[item.name]?.title}-${row.literatureUId}`"
            v-if="
              tableStyleTemp.lineHeightType == LINE_HEIGHT.FIT &&
              !row[item.name]?.edit
            "
            style="padding: 20px 15px"
          >
            {{ row[item.name]?.data }}
          </div>
          <div
            class="cell-content"
            v-if="
              tableStyleTemp.lineHeightType !== LINE_HEIGHT.FIT &&
              !row[item.name]?.edit
            "
            :style="{
              height: tableStyleTemp.lineHeight - 20 + 'px',
            }"
          >
            <!-- overflow: hidden; -->
            <div
              :class="`cell-text-${row[item.name]?.title}-${row.literatureUId}`"
              style="
                display: -webkit-box;
                -webkit-box-orient: vertical;
                overflow: hidden;
              "
              :style="{
                '-webkit-line-clamp': getRowCounts(
                  tableStyleTemp.lineHeight - 20
                ),
              }"
            >
              <div class="cell-label">
                {{ row[item.name]?.data }}
              </div>
            </div>
          </div>
          <div
            class="cell-edit"
            v-if="row[item.name]?.edit"
            style="width: 100%"
            :style="{ height: row.height + 'px' }"
          >
            <textarea
              class="edit-textarea"
              placeholder="请输入"
              v-model="row[item.name].data"
              @keydown.enter="
                (event) => {
                  if (event.altKey) {
                    row[item.name].data += '\n';
                  }
                  if (!event.shiftKey && !event.altKey) {
                    event.preventDefault(); // 阻止默认的换行行为
                    saveEdit(row[item.name], row.literatureUId);
                  }
                }
              "
              style="width: 100%; height: 100%"
            ></textarea>
            <!-- :style="{
                width:
                  row[item.name].columnWidth - 20 ||
                  tableStyleTemp.columnWidth - 20 + 'px',
                height: tableStyleTemp.lineHeight + 'px',
              }" -->
          </div>
          <div class="line-icon" v-show="row[item.name]?.ifShowAllIcon">
            <div class="line-option">
              <div v-show="row[item.name]?.ifShowOpenIcon">
                <el-popover
                  placement="right"
                  :width="250"
                  trigger="click"
                  popper-class="line-icon-popover"
                  :visible="row[item.name]?.ifOpenPopper"
                >
                  <template #default>
                    <div class="popper-content">
                      {{ row[item.name]?.data }}
                    </div>
                  </template>
                  <template #reference>
                    <div
                      class="option-icon"
                      @click="togglePopovers(row[item.name])"
                    >
                      <i class="iconfont icon-icon_chakan"></i>
                    </div>
                  </template>
                </el-popover>
              </div>
              <div class="option-icon" @click="handleClickEdit(row[item.name])">
                <i class="iconfont icon-bianji"></i>
              </div>
            </div>
          </div>
        </template>
      </el-table-column>
      <el-table-column>
        <template #header>
          <PopperAddCompare
            v-model:visible="addPoppervisible"
            :placement="'left'"
            @add="handleAddComparisonItem"
          >
            <template #content>
              <div class="tab-text" @click="openCard" style="cursor: pointer">
                <i class="iconfont icon-icon-10"></i>
              </div>
            </template>
          </PopperAddCompare>
        </template>
      </el-table-column>
    </el-table>
    <DrawerUpdateCompare ref="drawerUpdateComparisonRef" @refresh="refresh" />
  </div>
</template>

<script setup>
import {
  ref,
  watch,
  defineProps,
  computed,
  defineEmits,
  onMounted,
  nextTick,
  reactive,
  defineExpose,
  onBeforeUnmount,
} from "vue";
import { httpPost } from "@/api/httpService.js";
import PopperAddCompare from "./components/PopperAddCompare.vue";
import DrawerUpdateCompare from "./components/DrawerUpdateCompare.vue";
import { confirmBox } from "@/utils/messageBox.js";
import { bus } from "@/utils/mitt.js";
import { ElMessage } from "element-plus";
import { SYSTEM_STYLE } from "@/constant/compare.js";
import { COMPARE_TITLE_VISIBLE } from "@/constant/compare.js";
import { AI_READING_TYPE_IMAGE } from "@/constant/ai_reading_type.js";

const LINE_HEIGHT = {
  FIT: 1,
  NOFIT: 2,
};
const emits = defineEmits(["select", "update", "loading", "refresh"]);
const props = defineProps({
  tableColumns: {
    type: Array,
    default: () => [],
  },
  tableData: {
    type: Array,
    default: () => [],
  },
  tableStyle: {
    type: Object,
    default: () => {},
  },
  ifLoading: {
    type: Boolean,
    default: false,
  },
  id: {
    type: String,
    default: "",
  },
  readingResultUpdateTimeMap: {
    type: Object,
    default: () => {},
  },
});
const tableColumnsTemp = ref([]); //表头数据
const tableDataTemp = ref([]); //表格数据
//表格样式
const tableStyleTemp = reactive({
  titleColumnWidth: "", //标题的宽
  lineHeightType: "", //行高类型：1.自适应/2.非自适应
  columnWidth: SYSTEM_STYLE.WIDTH, //系统默认行宽
  lineHeight: SYSTEM_STYLE.HEIGHT, //系统默认行宽
});
const comparisonUid = ref(""); //对比id
const tableRef = ref(null);
//获取表格行高度更新表格
const getCellHeightUpdateTable = (result) => {
  const tableRows = tableRef.value.$el.querySelectorAll(".el-table__row");
  let data = result.map((item, index) => {
    return {
      ...item,
      height: tableRows[index].offsetHeight,
    };
  });
  return data;
};
watch(
  () => props.tableColumns,
  (newVal, oldVal) => {
    tableColumnsTemp.value = JSON.parse(JSON.stringify(newVal));
  },
  { immediate: true, deep: true }
);
watch(
  () => props.tableData,
  (newVal, oldVal) => {
    if (newVal.length > 0) {
      tableDataTemp.value = JSON.parse(JSON.stringify(newVal));
      nextTick(() => {
        tableDataTemp.value = getCellHeightUpdateTable(tableDataTemp.value);
      });
    }
  },
  { immediate: true, deep: true }
);
watch(
  () => props.id,
  (newVal, oldVal) => {
    comparisonUid.value = newVal;
  },
  { immediate: true, deep: true }
);
watch(
  () => props.tableStyle,
  (newVal, oldVal) => {
    const { columnWidth, lineHeight, lineHeightType, titleColumnWidth } =
      newVal;
    tableStyleTemp.titleColumnWidth = titleColumnWidth || SYSTEM_STYLE.WIDTH;
    tableStyleTemp.lineHeightType = lineHeightType;
    tableStyleTemp.columnWidth = columnWidth || SYSTEM_STYLE.WIDTH;
    tableStyleTemp.lineHeight = lineHeight || SYSTEM_STYLE.HEIGHT;
  },
  { immediate: true, deep: true }
);
const _readingResultUpdateTimeMap = ref({}); //ai阅读更新时间map
watch(
  () => props.readingResultUpdateTimeMap,
  (newVal, oldVal) => {
    if (newVal) {
      _readingResultUpdateTimeMap.value = JSON.parse(JSON.stringify(newVal));
    }
  },
  { immediate: true, deep: true }
);
//是否显示更新按钮
const showUpdateButton = computed(() => {
  //如果ai阅读的更新时间晚于这个对比更新时间
  return (row) => {
    let readTimestamp = new Date(
      _readingResultUpdateTimeMap.value[row.literatureUId]
    ).getTime();
    let compareTimestamp = new Date(row.readCompareTime).getTime();
    return readTimestamp > compareTimestamp;
  };
});
//选中的表格数据
const idSelectedList = ref([]);
const handleSelectionChange = (value) => {
  idSelectedList.value = value.map((item) => {
    return item.literatureUId;
  });
  emits("select", idSelectedList.value);
};
//更新
const drawerUpdateComparisonRef = ref(null);
const handleClickUpdate = (row, type) => {
  drawerUpdateComparisonRef.value.openDWR({
    comparisonUid: comparisonUid.value,
    comparisonItems: tableColumnsTemp.value,
    data: row,
    type: type,
  });
};
//忽略更新
const handleClickIgnoreUpdate = (row) => {
  confirmBox(`确定忽略本次更新吗？
`).then(async () => {
    let params = {
      comparisonUid: comparisonUid.value,
      literatureUid: row.literatureUId,
      modifyDataList: null,
      isNeedUpdateCompareTime: true,
    };
    let res = await httpPost("/comparison/v1/updateComparison", params);
    if (res.code == 0) {
      ElMessage.success("忽略成功");
      refresh();
    }
  });
};
//编辑
const handleClickEdit = (cell) => {
  cell.edit = true;
  cell.ifShowAllIcon = false;
};
//保存修改
const saveEdit = async (cell, id) => {
  // confirmBox("确认保存此次修改吗？").then(async () => {
  cell.edit = false;
  let params = {
    comparisonUid: comparisonUid.value,
    literatureUid: id,
    modifyDataList: [
      {
        title: cell.title,
        content: cell.data.replace(/\n\s*$/, ""),
      },
    ],
    isNeedUpdateCompareTime: false,
  };
  let res = await httpPost("/comparison/v1/updateComparison", params);
  if (res.code == 0) {
    ElMessage.success("修改成功");
  } else {
    refresh();
  }
  // });
};

//打开弹出框
const togglePopovers = (cell) => {
  cell.ifOpenPopper = !cell.ifOpenPopper;
};
//关闭弹出框
const closePopovers = () => {
  tableDataTemp.value.forEach((item) => {
    Object.keys(item).forEach((key) => {
      if (
        item[key] &&
        typeof item[key] === "object" &&
        item[key].ifOpenPopper
      ) {
        item[key].ifOpenPopper = false;
      }
    });
  });
};
//某一单元格样式
const hoveredRowIndex = ref("");
const hoveredColumnIndex = ref("");
const getCellStyle = computed(() => {
  return (params) => {
    if (
      params.rowIndex === hoveredRowIndex.value &&
      params.columnIndex === hoveredColumnIndex.value
    ) {
      return {
        backgroundColor: "#f5f5f5",
      };
    }
    return {};
  };
});
//鼠标进入某个单元格
const handleMouseEnter = (row, column) => {
  hoveredRowIndex.value = tableDataTemp.value.indexOf(row);
  hoveredColumnIndex.value = column.getColumnIndex(column.property);
  let title = column.property;
  if (title && title == "title") {
    row.ifShowTitleIcon = true;
  } else if (title && title !== "title" && !row[title]?.edit) {
    row[title].ifShowAllIcon = true;
    if (tableStyleTemp.lineHeightType !== LINE_HEIGHT.FIT) {
      checkOverflow(row[title], row.literatureUId);
    }
  }
};
//鼠标离开某个单元格
const handleMouseLeave = (row, column) => {
  hoveredRowIndex.value = "";
  hoveredColumnIndex.value = "";
  let title = column.property;
  if (title && title == "title") {
    row.ifShowTitleIcon = false;
  } else if (title && title !== "title") {
    if (!row[title].ifOpenPopper) {
      row[title].ifShowAllIcon = false;
      row[title].ifShowOpenIcon = false;
    }
  }
};
//检查是否溢出
const checkOverflow = (cell, id) => {
  if (cell.data) {
    const el = document.querySelector(`.cell-text-${cell.title}-${id}`);
    if (el.scrollHeight > el.clientHeight) {
      cell.ifShowOpenIcon = true;
    }
  }
};
//获取行数
const getRowCounts = (height) => {
  const result = Math.floor(height / 24);
  return result;
};
//更新样式
bus.on("update-table-style", (params) => {
  const { ifDefault, columnWidth, lineHeight, lineHeightType } = params;
  if (ifDefault) {
    //系统默认
    columnWidthPerColumnList.value = tableColumnsTemp.value.map((item) => {
      item.columnWidth = null;
      return item;
    });
  } else {
    columnWidthPerColumnList.value = tableColumnsTemp.value;
  }
  tableStyleTemp.columnWidth = columnWidth;
  tableStyleTemp.lineHeight = lineHeight;
  tableStyleTemp.lineHeightType = lineHeightType;
  //重新获取表格数据（高度）
  nextTick(() => {
    tableDataTemp.value = getCellHeightUpdateTable(tableDataTemp.value);
  });
  updateComparisonStyle();
});
//当前拖拽的的信息
const columnWidthPerColumnList = ref([]);
//标题的宽度
const updateComparisonStyle = () => {
  let params = {
    comparisonUid: comparisonUid.value,
    columnWidthPerColumnList: columnWidthPerColumnList.value,
    styleInfo: {
      ...tableStyleTemp,
      titleColumnWidth: tableStyleTemp.titleColumnWidth,
    },
  };
  httpPost("/comparison/v1/updateComparisonStyle", params);
  columnWidthPerColumnList.value = [];
};

//拖拽表头
const handleDragTableWidth = (newWidth, oldWidth, column) => {
  //判断拖动的是标题还是比较项
  if (column.property == "title") {
    tableStyleTemp.titleColumnWidth = newWidth;
    columnWidthPerColumnList.value = tableColumnsTemp.value.map((item) => {
      return { name: item.name, columnWidth: item.columnWidth };
    });
  } else {
    columnWidthPerColumnList.value = tableColumnsTemp.value.map((item) => {
      if (item.name == column.property) {
        item.columnWidth = newWidth;
      }
      return { name: item.name, columnWidth: item.columnWidth };
    });
  }
  updateComparisonStyle();
};
//#region 添加比较项
//更新比较项表头数据
const handleUpdateComparisonItems = async () => {
  let title = tableColumnsTemp.value.map((item) => {
    const { label, ...rest } = item;
    return rest;
  });
  let params = {
    comparisonUid: comparisonUid.value,
    title: title,
  };
  let res = await httpPost("/comparison/v1/updateComparisonTitle", params);
  if (res.code == 0) {
    ElMessage.success("操作成功");
  }
};
const addPoppervisible = ref(false);
const openCard = () => {
  addPoppervisible.value = true;
};
//添加比较项
const handleAddComparisonItem = async (params) => {
  tableColumnsTemp.value.push(params);
  await handleUpdateComparisonItems();
  emits("update", { type: "ADD", data: tableColumnsTemp.value });
};
//#endregion

//更新
const refresh = () => {
  emits("refresh");
};

//滚动时查看弹框消失
const handleScroll = (event) => {
  closePopovers();
};

onMounted(() => {
  const tableBodyWrapper = tableRef.value.$el.querySelector(
    ".el-scrollbar__wrap"
  );
  if (tableBodyWrapper) {
    tableBodyWrapper.addEventListener("scroll", handleScroll);
  }
});

onBeforeUnmount(() => {
  const tableBodyWrapper = tableRef.value.$el.querySelector(
    ".el-scrollbar__wrap"
  );
  if (tableBodyWrapper) {
    tableBodyWrapper.removeEventListener("scroll", handleScroll);
  }
});

defineExpose({ closePopovers });
</script>

<style lang="scss" scoped>
.comparison-table {
  padding: 20px;
  padding-top: 0;
  height: 100%;
  :deep(.el-table__header) {
    height: 56px;
  }
  .el-table {
    border: 1px solid #ececec;
    height: 100%;
    .fit-content {
      padding: 18px 0px;
    }
    .cell-content {
      .cell-text {
      }
      .cell-label {
        @include paragraph();
        line-height: 24px;
        padding: 0px 15px;
      }
      .cell-edit {
        position: absolute;
        top: 0;
        left: 0;
        height: 230px;
        width: 100%;
        z-index: 99999;
        .edit-textarea {
          font-size: 14px;
          padding: 10px;
          color: rgba(108, 108, 108, 1);
        }
      }
    }
    .line-icon {
      float: right;
      margin-bottom: 0;
      position: absolute;
      bottom: 1px;
      right: 5px;
      height: 24px;
      line-height: 24px;
      .line-option {
        display: flex;
        align-items: center;
        height: 24px;
        .option-icon {
          width: 20px;
          height: 20px;
          margin-left: 5px;
          padding: 2px;
          text-align: center;
          line-height: 16px;
          cursor: pointer;
          .icon-icon_chakan {
            font-size: 14px;
          }
          .icon-bianji {
            font-size: 15px;
          }
          .icon-jichu_gengxin {
            font-size: 13px;
            color: $theme-color;
          }
          .icon-a-wenxianduibizhankai {
            font-size: 12px;
          }
        }
        .option-text {
          width: 60px;
          height: 20px;
          margin-left: 5px;
          padding: 2px;
          text-align: center;
          line-height: 16px;
          cursor: pointer;
          .ignore-update {
            font-size: 12px;
            color: #bcbcbc;
          }
        }
        .option-icon:hover {
          border-radius: 3px;
          background-color: rgba(213, 213, 213, 1);
        }
      }
    }
  }
  :deep(.cell) {
    padding: 0;
  }
  :deep(th > .cell) {
    padding: 0 15px;
  }
  :deep(.el-table-column--selection > .cell) {
    padding: 0 15px;
  }
  :deep(.el-table__body .el-table__row.hover-row td) {
    background-color: #fff;
  }
  :deep(.el-table .el-table__cell) {
    padding: 0;
  }
  :deep(
      .el-table.is-scrolling-left.el-table--border
        .el-table-fixed-column--left.is-last-column.el-table__cell
    ) {
    // border-right: 0;
  }
  :deep(.el-table--border .el-table__cell) {
    // border-right: 0;
  }
}
.cell-hover {
  background-color: red;
}
.header-img {
  width: 16px;
  height: 16px;
  margin-right: 5px;
  display: inline-block;
  vertical-align: middle;
}
.line-icon-popover {
  padding: 10px;
  .popper-content {
    padding: 5px 5px 5px 10px;
    @include paragraph();
    max-height: 320px;
    overflow-y: auto;
    line-height: 22px;
  }
}
textarea {
  // background-color: pink;
  // border: 0;
  // font-family: Microsoft Yahei;
  color: #606266;
  font: 14px/1.14 arial, Microsoft Yahei;
  line-height: 22px;
  padding: 5px;
  border: 2px solid $theme-color;
  @include paragraph();
}
textarea::placeholder {
  color: #d5d5d5;
}
</style>
